// eslint-disable-next-line import/prefer-default-export
export function brandedId() {
  return `ambiki-${Math.random().toString().slice(2, 6)}`;
}
